var _defs, _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2689a8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.38,175.1l-40.1-41.8a4.33,4.33,0,0,0-2.58-1.3,7.32,7.32,0,0,0,3.34-6.14V24a7.34,7.34,0,0,0-7.32-7.33H56.28A7.34,7.34,0,0,0,49,24V125.86A7.32,7.32,0,0,0,52.3,132a4.33,4.33,0,0,0-2.58,1.3L9.62,175.1c-2.88,3-.92,8.28,3.08,8.28H287.3C291.3,183.38,293.26,178.1,290.38,175.1Zm-46.66-44.29H56.28a5,5,0,0,1-4.94-5V24A5,5,0,0,1,56.28,19H243.72A5,5,0,0,1,248.66,24V125.86A5,5,0,0,1,243.72,130.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.71,38H89a4.34,4.34,0,0,0-4.34,4.34v66.6A4.34,4.34,0,0,0,89,113.24h50.75a4.34,4.34,0,0,0,4.34-4.34V42.3A4.35,4.35,0,0,0,139.71,38Zm2,70.94a2,2,0,0,1-2,2H89a2,2,0,0,1-2-2V42.3a2,2,0,0,1,2-2h50.75a2,2,0,0,1,2,2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.63,
    y: 89.07,
    width: 51.51,
    height: 3.74
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.63,
    y: 96.32,
    width: 51.51,
    height: 3.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.63,
    y: 103.56,
    width: 51.51,
    height: 3.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopPhoto);
export default __webpack_public_path__ + "static/media/laptopPhoto.b342705e6fa9149e61bfa8e576fe8628.svg";
export { ForwardRef as ReactComponent };